<header id="page-topbar" style="z-index: 1000;">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/tecsa.png" alt="" height="30">
          </span>
          <span class="logo-lg">
            <img src="assets/images/tecsa-dark.png" alt="" height="30">
          </span>
        </a>

        <a routerLink="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/tecsalogo.png" alt="" height="30">
          </span>
          <span class="logo-lg">
            <img src="assets/images/tecsalogo.png" alt="" height="30">
          </span>
        </a>
      </div>

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn" id="vertical-menu-btn" (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>

      <div class="app-search d-none d-lg-block" *ngIf="showText && tipoCliente !== null" style="min-width: 700px;">
        <div class="d-flex align-items-center p-0 dimensiones">
          <div class="d-flex align-items-center">
            <div class="me-3">
              <i class="uil uil-dollar-sign-alt text-white h2"></i>
            </div>
            <div style="margin-left: -5px; display: flex;">
              <h5 class="font-size mb-0 green" *ngIf="tipoCliente === '2'">{{ showSaldo | currency }} MXN</h5>
              <h5 class="font-size mb-0 green" *ngIf="tipoCliente === '1'">UTAE: {{ showSaldo | number:'1.0-3' }}</h5>
            </div>
          </div>
          <div style="margin-left: 2%;">
            <p class="mb-0">
              <i class="mdi mdi-circle-medium green me-0"></i>
              Saldo actual
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">

      <div class="dropdown d-inline-block d-lg-none ms-2" ngbDropdown *ngIf="showText && tipoCliente !== null" >
        <div class="d-flex align-items-start align-items-center p-3 dimensiones_small">
          <div class="me-3">
            <i class="uil uil-dollar-sign-alt text-white h2"></i>
          </div>
          <div class="flex-1 overflow-hidden">
            <h5 class="font-size mb-0 green" *ngIf="tipoCliente === '2'">{{ showSaldo | currency }} MXN</h5>
            <h5 class="font-size mb-0 green" *ngIf="tipoCliente === '1'">UTAE: {{ showSaldo | number:'1.0-3' }}</h5>
          <p class="text-muted text-truncate mb-0">
              <i class="mdi mdi-circle-medium green me-0"></i>
              Saldo actual
            </p>
          </div>
          <!-- <div class="flex-shrink-0">
            <button type="button" (click)="irPuntoVenta()" class="btn btn-primary align btn-sm btn-rounded waves-effect waves-light">
              Punto de Venta
            </button>
          </div> -->
        </div>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" ngbDropdownMenu aria-labelledby="page-header-search-dropdown">

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- <div class="dropdown d-inline-block language-switch" ngbDropdown>
        <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown" ngbDropdownToggle>
          @if(flagvalue === undefined){
          <img src="{{valueset}}" alt="Header Language" height="16">
          }@else{
          <img src="{{flagvalue}}" alt="Header Language" height="16">
          }
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu> -->
          <!-- item-->
          <!-- @for(item of listLang;track $index){
          <a href="javascript:void(0);" class="dropdown-item notify-item" (click)="setLanguage(item.text, item.lang, item.flag)" [ngClass]="{'active': cookieValue === item.lang}">
            <img src="{{item.flag}}" alt="user-image" class="me-1" height="12">
            <span class="align-middle">{{item.text}}</span>
          </a>} -->
          <!-- item-->
        <!-- </div>
      </div> -->

      <!-- <div class="dropdown d-none d-lg-inline-block ms-1" ngbDropdown>
        <button type="button" class="btn header-item noti-icon waves-effect" ngbDropdownToggle>
          <i class="uil-apps"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end" ngbDropdownMenu>
          <div class="px-lg-2">
            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/github.png" alt="Github">
                  <span>GitHub</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/bitbucket.png" alt="bitbucket">
                  <span>Bitbucket</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dribbble.png" alt="dribbble">
                  <span>Dribbble</span>
                </a>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/dropbox.png" alt="dropbox">
                  <span>Dropbox</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/mail_chimp.png" alt="mail_chimp">
                  <span>Mail Chimp</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="assets/images/brands/slack.png" alt="slack">
                  <span>Slack</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="dropdown d-none d-lg-inline-block ms-1">
        <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" (click)="fullscreen()">
          <i class="uil-minus-path"></i>
        </button>
      </div>

      <div *ngIf="showSwitchs">
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" (click)="goSwitcheo()">
            <i class="uil-toggle-off"></i>
          </button>
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item noti-icon waves-effect" id="page-header-notifications-dropdown" ngbDropdownToggle>
          <i class="uil-wallet"></i>
          <!-- <span class="badge bg-danger rounded-pill">3</span> -->
        </button>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0 font-size-16">Balance Global</h6>
              </div>
              <div class="col-auto">
                <!-- <a href="javascript: void(0);" class="small">{{ 'HEADER.NOTIFICATIONS.VIEW_ALL' | translate}}</a> -->
              </div>
            </div>
          </div>
          <ngx-simplebar style="position: relative; height: auto;">
            <a class="text-dark notification-item">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar-xs">
                    <span class="avatar-title bg-success rounded-circle font-size-20">
                      <i class="uil-money-withdraw"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1 text-success">{{ totalAsignado | currency:'':'symbol':'1.2-2' }} MXN</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      <i class="mdi mdi-circle-medium me-2 text-success"></i>
                      Saldo Asignado
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a class="text-dark notification-item">
              <div class="d-flex align-items-start">
                <div class="flex-shrink-0 me-3">
                  <div class="avatar-xs">
                    <span class="avatar-title bg-warning rounded-circle font-size-20">
                      <i class="uil-money-insert"></i>
                    </span>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mb-1 text-warning">{{ totalGastado | currency:'':'symbol':'1.2-2' }} MXN</h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1 ">
                      <i class="mdi mdi-circle-medium me-2 text-warning"></i>
                      Saldo Utilizado
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </ngx-simplebar>
        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown style="margin-left: -5px;">
        <button type="button" class="btn header-item waves-effect" style="display: flex; justify-content: center; align-items: center;" ngbDropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" [src]="imagenPerfil" alt="Header Avatar">
          <div style="display: grid; padding: 15px;">
            <span class="d-none d-xl-inline-block ms-1 fw-medium font-size-15">{{nombre}}</span>
            <span class="d-none d-xl-inline-block ms-1 fw-medium font-size-12" style="color: darkgrey;">{{rol}}</span>
          </div>
          <i class="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a class="dropdown-item" href="javascript: void(0);" (click)="irPerfil()">
            <i class="uil uil-user-circle font-size-18 align-middle text-muted me-1"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.PROFILE' | translate}}</span>
          </a>
          <ng-container *ngIf="this.showConfiguracion">
            <a class="dropdown-item d-block" href="javascript: void(0);" (click)="centerModal(centerDataModal)">
              <i class="uil uil-cog font-size-18 align-middle me-1 text-muted"></i>
              <span class="align-middle">{{ 'HEADER.LOGIN.SETTINGS' | translate}}</span>
            </a>
          </ng-container>
          
          <!-- <a class="dropdown-item" href="javascript: void(0);">
            <i class="uil uil-wallet font-size-18 align-middle me-1 text-muted"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.MY_WALLET' | translate}}</span>
          </a> -->
          <!-- <a class="dropdown-item d-block" href="javascript: void(0);" (click)="toggleRightSidebar()">
            <i class="uil uil-cog font-size-18 align-middle me-1 text-muted"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.SETTINGS' | translate}}</span>
          </a> -->
          <!-- <a class="dropdown-item" href="javascript: void(0);">
            <i class="uil uil-lock-alt font-size-18 align-middle me-1 text-muted"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.LOCK_SCREEN' | translate}}</span>
          </a> -->
          <a class="dropdown-item" href="javascript: void(0);" (click)="logout()">
            <i class="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            <span class="align-middle">{{ 'HEADER.LOGIN.LOGOUT' | translate}}</span>
          </a>
        </div>
      </div>

    </div>
  </div>
</header>

<div class="col-lg-6">
  <ng-template #centerDataModal let-modal>
    <div class="modal-header">
      <div class="mt-2">
        <h5 class="modal-title" id="staticBackdropLabel">Datos de Configuración:</h5>
        <p class="subtitle">Los campos marcados con <span class="text-danger">*</span> son obligatorios.</p>
      </div> 
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.close('Close click')">
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="configuracionForm">
        <!-- <div class="form-group mt-3">
          <i class="fa fa-print"></i>&nbsp;
          <label>Impresora: <span class="text-danger">*</span></label>
          <dx-select-box
            [items]="listaImpresoras"
            formControlName="idImpresora"
            valueExpr="id" 
            displayExpr="descripcion" 
            [noDataText]="'No se encontraron impresoras'" 
            placeholder="Seleccione una impresora">
          </dx-select-box>
        </div> -->
        <div class="form-group mt-3">
          <i class="fa fa-map-marker"></i>&nbsp;
          <label>Nombre Sucursal: <span class="text-danger">*</span></label>
          <dx-select-box formControlName="idSucursal" [items]="listaSucursales" [disabled]="noSelect"
          valueExpr="id" displayExpr="nombre"
          (onValueChanged)="onSucursalChange($event, 'sucursal')"></dx-select-box>
        </div>
        <div class="form-group mt-3">
          <i class="fa fa-pencil-square-o"></i>&nbsp;
          <label>Mensaje: <span class="text-danger">*</span></label> 
          <textarea required formControlName="mensaje" class="form-control" placeholder="Ingrese un mensaje" style="resize: none; height: 95px;"></textarea>
        </div>
        <div class="form-group mt-3">
          <i class="fa fa-pencil-square-o"></i>&nbsp;
          <label>Soporte: <span class="text-danger">*</span></label>
          <textarea required formControlName="soporte" class="form-control" placeholder="Soporte" style="resize: none; height: 95px;"></textarea>
        </div>        
        <!-- <div class="form-group mt-3">
          <i class="fa fa-pencil-square-o"></i>&nbsp;
          <label>Mensaje: <span class="text-danger">*</span></label> 
          <input required="" formControlName="mensaje" type="text"
          class="form-control" placeholder="Ingrese un mensaje">
        </div>
        <div class="form-group mt-3">
          <i class="fa fa-pencil-square-o"></i>&nbsp;
          <label>Soporte: <span class="text-danger">*</span></label>
          <input required="" formControlName="soporte" type="text"
          class="form-control" placeholder="Soporte"> 
        </div> -->
      </form>
    </div>  
    <div class="modal-footer row d-flex justify-content-center mt-4 border-footer">
      <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 mt-3">
        <button type="button" class="btn btn-success btn-lg mb-1 w-100"  (click)="guardarConfiguracion(modal)" [disabled]="configuracionForm.invalid" >
          <i class="fa fa-print" ></i>&nbsp;Guardar
        </button>
      </div>
      <div class="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 mt-3">
        <button type="button" class="btn btn-danger btn-lg mb-1 w-100" (click)="modal.close('Close click')">
          <i class="fa fa-times"></i>&nbsp;Cancelar
        </button>
      </div>
    </div> 
  </ng-template>
</div>